export const b2cPolicies = {
  names: {
    signUpSignIn: "B2C_1A_SIGNIN_ONLY",
    forgotPassword: "B2C_1A_PASSWORDRESET",
  },
  authorities: {
    signUpSignIn: {
      authority:
        "https://mliinterface.b2clogin.com/mliinterface.onmicrosoft.com/B2C_1A_SIGNIN_ONLY",
    },
    forgotPassword: {
      authority:
        "https://mliinterface.b2clogin.com/mliinterface.onmicrosoft.com/B2C_1A_PASSWORDRESET",
    },
  },
  authorityDomain: "mliinterface.b2clogin.com",
};

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: import.meta.env.VITE_REDIRECT_URL,
    postLogoutRedirectUri: import.meta.env.VITE_REDIRECT_URL,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const protectedResources = {
  api: {
    admin: import.meta.env.VITE_API_URL + "Admin",
    project: import.meta.env.VITE_API_URL + "Project",
    report: import.meta.env.VITE_API_URL + "Embed",
    dashboard: import.meta.env.VITE_API_URL + "Dashboard",
    download: import.meta.env.VITE_API_URL + "Download",
    user: import.meta.env.VITE_API_URL + "User",
    training: import.meta.env.VITE_API_URL + "Training",
    organization:import.meta.env.VITE_API_URL + "Organization",
    workspace: import.meta.env.VITE_API_URL + "Workspace",
    inventory: import.meta.env.VITE_API_URL + "Inventory",
    productHistory: import.meta.env.VITE_API_URL + "Inventory/history",
    scopes: [import.meta.env.VITE_SCOPES],
  },
};

export const loginRequest = {
  scopes: [...protectedResources.api.scopes],
};

export const logoutRequest = {
  mainWindowRedirectUri: import.meta.env.VITE_REDIRECT_URL,
  postLogoutRedirectUri: import.meta.env.VITE_REDIRECT_URL,
};


